import Vue from "vue";
const times = {
    time: function(d) {
        let getFullYear = d.getFullYear();
        let getMonth = d.getMonth() + 1< 10 ? "0" + (d.getMonth()+1):d.getMonth()+1;
        let getDate = d.getDate()< 10 ? "0" + d.getDate() : d.getDate();
        let getHours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let getMinutes =
            d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let getSeconds =
            d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let datetime =
            getFullYear +
            "-" +
            getMonth +
            "-" +
            getDate +
            " " +
            getHours +
            ":" +
            getMinutes +
            ":" +
            getSeconds;
        return datetime;
    }
};

Vue.prototype.times = times;
// export default {};


// WEBPACK FOOTER //
// ./src/serve/api/time.js